import React, { useEffect, useState } from "react";
import "./style.css";
import { Quoter } from "@a365/quoter";
import { APP_CONFIGURATION } from "../../core/a365_home.config";

// Optimizado para mejor rendimiento LCP
const Hero = ({ openMod, setOpenMod }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [quoterLoaded, setQuoterLoaded] = useState(false);
  const config = APP_CONFIGURATION.externals.quoter;

  useEffect(() => {
    // Agregar clase de "loaded" al cuerpo para indicar que el Hero está visible
    document.body.classList.add('hero-visible');
    
    // Iniciar un temporizador para marcar el componente como cargado incluso si hay demoras
    const timer = setTimeout(() => {
      setQuoterLoaded(true);
    }, 300);
    
    return () => {
      clearTimeout(timer);
      document.body.classList.remove('hero-visible');
    };
  }, []);

  // Función para manejar la carga del Quoter
  const handleQuoterLoaded = () => {
    setQuoterLoaded(true);
  };

  // Función para manejar fetch de productos
  const fetchProducts = (e) => {
    console.log(e);
    // Implementación real aquí
  };

  return (
    <div
      className={`hero min-h-[252px] lg:min-h-[296px] w-full flex items-start justify-center z-50 ${
        isOpen
          ? "absolute left-0 right-0 z-[9999]"
          : "relative lg:pt-4 _md:pt-8 z-[101]"
      }`}
    >
      {overlay && <div className="bg-black/25 absolute inset-0"></div>}

      <div className={overlay ? "_absolute z-[99999]" : "w-full flex items-center justify-center"}>
        {/* Mostrar inmediatamente el formulario sin esperar */}
        <Quoter
          fetchProducts={fetchProducts}
          init={config}
          mode="default"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setOverlay={setOverlay}
          overlay={overlay}
          openMod={openMod}
          setOpenMod={setOpenMod}
          onLoad={handleQuoterLoaded}
          visible={true}
        />
      </div>
    </div>
  );
};

export default Hero;
